import { ChangeDetectionStrategy, Component, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

import { StepService } from './step.service';
import { StepState } from './step.state';
import { Subject, takeUntil, timer } from 'rxjs';

@Component({
  selector: 'ik-screen-step',
  templateUrl: './screen-step.component.html',
  styleUrls: ['./screen-step.component.scss'],
  animations: [
    trigger('fadeAnimation', [
      transition('* => *', [
        style({ opacity: 0 }),
        animate('1.5s ease-in', style({ opacity: 1 }))
      ])
    ])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreenStepComponent implements OnInit, OnDestroy{

  public state$ = this.stepService.getStepState();

  public displayedSection: string | null = null;
  
  private waiting = false;

  private destroy = new Subject<void>();

  constructor(
    private stepService: StepService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
  }

  public ngOnInit(): void {
    this.getDisplayedSection();
  }

  private getDisplayedSection(): void {
    this.state$
    .pipe(takeUntil(this.destroy))
    .subscribe(state => {
      const currentSection = this.getCurrentSection(state);
      if (currentSection !== this.displayedSection && !this.waiting) {
        this.waiting = true;

        timer(400)
          .pipe(takeUntil(this.destroy))
          .subscribe(() => {
            this.waiting = false;
            this.displayedSection = currentSection;
            this.changeDetectorRef.markForCheck();
          })
      }
    });
  }

  // Вспомогательная функция для получения текущей секции (копия из Pipe)
  private getCurrentSection(state: StepState): string | null {
    if (!state.useSections || !state.onboardingSections.length) {
      return null;
    }
    let stepCounter = 0;
    for (const section of state.onboardingSections) {
      stepCounter += section.length;
      if (state.step < stepCounter) {
        return section.name;
      }
    }
    return state.onboardingSections[state.onboardingSections.length - 1].name;
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

}
